export const PRINT_WAREHOUSE_KITCHEN_HOLD_REPORTS_LOADING =
  'PRINT_WAREHOUSE_KITCHEN_REPORTS_LOADING';
export const PRINT_WAREHOUSE_KITCHEN_AVAI_REPORTS_LOADING =
  'PRINT_WAREHOUSE_KITCHEN_AVAILABILITY_REPORTS_LOADING';
export const PRINT_LOADING_ERROR = 'PRINT_LOADING_ERROR';
export const CLEAR_PRINT_LOADING_ERROR = 'CLEAR_PRINT_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/state/types.js